import React from "react"
import PropTypes from "prop-types"

import { Title } from "./styles"

const SectionTitle = ({ children, light, align }) => {
  return (
    <Title light={light} align={align}>
      {children}
    </Title>
  )
}

SectionTitle.propTypes = {
  children: PropTypes.string.isRequired,
  light: PropTypes.bool,
  align: PropTypes.oneOf(["left", "center", "right"]),
}

export default SectionTitle
